import type { PayPeriodSchema } from '@libs/data-access/queries'
import { useMutation } from '@tanstack/react-query'

import { appQueryClient } from '../../../provider'
import type { ApiErrorResponse, UseAppMutationOptions } from '../../../types'
import type { DeletePayPeriodOptions } from '../payPeriod.api'
import { deletePayPeriod } from '../payPeriod.api'
import { payPeriodsQueryKeys } from '../payPeriod.queryKeys'

export const useDeletePayPeriod = (
  mutationOptions?: UseAppMutationOptions<
    PayPeriodSchema,
    ApiErrorResponse,
    DeletePayPeriodOptions
  >
) => {
  return useMutation<PayPeriodSchema, ApiErrorResponse, DeletePayPeriodOptions>(
    {
      ...mutationOptions,
      mutationKey: payPeriodsQueryKeys.delete(),
      mutationFn: opts => deletePayPeriod(opts),
      onSuccess: (data, variables, ...args) => {
        if (mutationOptions?.onSuccess) {
          mutationOptions?.onSuccess(data, variables, ...args)
        }
        appQueryClient.invalidateQueries({
          queryKey: payPeriodsQueryKeys.all()
        })
      }
    }
  )
}
